interface EventPayload {
  type: 'recordings::listen_event_type';
}

export interface RecordingListenEventPayload extends EventPayload {
  recording_id: string;
  owner_id: string;
  minute: number;
  recording_duration_minutes: number;
  recording_title: string;
}

export async function sendEvent(payload: EventPayload): Promise<boolean> {
  const result = await fetch(
    `${process.env.REACT_APP_API_GATEWAY_SEND_EVENT}`,
    {
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    }
  );

  if (result.ok) {
    return true;
  } else {
    return false;
  }
}
